package com.kitco.scrapit

val String.isDecimalNumber get() = "^\\d*\\.?\\d*\$".toRegex().matches(this)
